import { Box as Box$1, Stack as Stack$1 } from "../mantine-passthroughs/index.js";
import { CoverProviderContext } from "../cover/CoverProviderContext.js";
import { NavBar } from "../nav-bar/NavBar.js";
import { StickyFooterProviderContext } from "../sticky-footer/StickyFooterProviderContext.js";
import app_shell_main_module_default from "./app-shell-main.module.js";
import { AppShell } from "@mantine/core";
import { useRef, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/app-shell/AppShell.tsx
const AppShell$1 = (appShellProps) => {
	const { header, footer, navBarProps, children, maxWidth = "800px", footerBg = "inherit", navbarBg = "inherit", "data-testid": testId } = appShellProps;
	const coverPageRef = useRef(null);
	const stickyFooterTarget = useRef(null);
	const [hasStickyFooter, setHasStickyFooter] = useState(false);
	const [footerHeight, setFooterHeight] = useState(-1);
	return /* @__PURE__ */ jsxs(AppShell, {
		display: "flex",
		style: { flexDirection: "column" },
		mih: "100svh",
		withBorder: false,
		"data-testid": testId,
		children: [
			/* @__PURE__ */ jsx(AppShell.Navbar, {
				bg: navbarBg,
				h: "auto",
				pos: "relative",
				children: /* @__PURE__ */ jsx(Box$1, {
					m: "0 auto",
					w: "100%",
					maw: maxWidth,
					children: /* @__PURE__ */ jsx(NavBar, { ...navBarProps ?? {} })
				})
			}),
			header ? /* @__PURE__ */ jsx(AppShell.Header, {
				h: "auto",
				pos: "relative",
				w: "100%",
				maw: maxWidth,
				m: "0 auto",
				children: header
			}) : null,
			/* @__PURE__ */ jsx(AppShell.Main, {
				display: "flex",
				flex: "1",
				pb: hasStickyFooter ? `calc(${footerHeight}px + calc(2.5 * var(--mantine-spacing-sm)))` : "xl",
				pt: "lg",
				px: "sm",
				style: { flexDirection: "column" },
				mih: "unset",
				classNames: app_shell_main_module_default,
				children: /* @__PURE__ */ jsx(Stack$1, {
					gap: 0,
					m: "0 auto",
					w: "100%",
					flex: "1",
					maw: maxWidth,
					pos: "relative",
					ref: coverPageRef,
					children: /* @__PURE__ */ jsx(StickyFooterProviderContext.Provider, {
						value: {
							appFooter: footer,
							footerBg,
							maxWidth,
							setFooterHeight,
							setHasStickyFooter,
							stickyFooterTarget
						},
						children: /* @__PURE__ */ jsx(CoverProviderContext.Provider, {
							value: { coverPageTarget: coverPageRef },
							children
						})
					})
				})
			}),
			hasStickyFooter ? /* @__PURE__ */ jsx(Box$1, { ref: stickyFooterTarget }) : null,
			footer && !hasStickyFooter ? /* @__PURE__ */ jsx(AppShell.Footer, {
				pos: "relative",
				p: "sm",
				bg: footerBg,
				children: /* @__PURE__ */ jsx(Box$1, {
					w: "100%",
					maw: maxWidth,
					m: "0 auto",
					children: footer
				})
			}) : null
		]
	});
};

//#endregion
export { AppShell$1 as AppShell };